module.exports = __webpack_public_path__ + "fb09bf78.png";